import React from 'react';
import _ from 'lodash';

import { useStoreListActivityQuery } from 'generated/graphql';



export interface IStore {
  id: string;
  name: string;
  logoUrl: string;
}

export interface IData {
  stores: IStore[];
  isSuperAdmin: boolean;
}

export function useQuery() {
  const tuple = useStoreListActivityQuery({});



  return React.useMemo(
    () => {
      const permissions = _.map(tuple.data?.loggedInUser?.permissions, (permission): string => permission.name);
      const data: IData = {
        stores: _.map(tuple.data?.stores.nodes ?? [], (store): IStore => ({
          id: store.id,
          logoUrl: store.logoUrl,
          name: store.name
        })),
        isSuperAdmin: (tuple.data?.loggedInUser?.isSuperAdmin || _.includes(permissions, 'platform_godMode')) ?? false
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
